<template>
    <div class="rhythmClass">
        <el-col :span="24" class="imgStyle" align="left">
            <el-button type="text" class="aginOnce" @click="resetLine">重置</el-button>
            <div style="clear:both;"></div>
            <!-- 连线 -->
            <div class="optionsHaveValue" :id="`diagramContainer${serial}`" style="position: relative;">
                
                <div :class="['line-box',`line-box${index+1}`]" v-for="(item,index) in rhythmBeatVal2" :key="index">
                    <div :class="['lBox-top',item.answerMsgImg?'':'lBox-top-no']">
                        <p class="an-text">{{item.answerMsgText}}</p>
                        <div class="an-img" v-if="item.answerMsgImg" v-html="item.answerMsgImg">{{item.answerMsgImg}}</div>
                        <div :class="['an-x',`an-x${index+1}`]" :ref="`anX${index+1}`" :id="`anXx${index}_${serial}`"></div>
                    </div>
                    <div :class="['lBox-bottom',item.answerMsgImg?'':'lBox-bottom-no']">
                        <div :class="['m-x',`m-x${index+1}`]" :ref="`mX${index+1}`" :id="`mXx${index}_${serial}`"></div>
                        <div class="m-img" :style="{height:rhythmBeatVal1[index].msgImg? '':'0%'}" v-html="rhythmBeatVal1[index].msgImg">{{rhythmBeatVal1[index].msgImg}}</div>
                        <p class="m-text">{{rhythmBeatVal1[index].msgText}}</p>
                    </div>
                </div>

            </div>
        </el-col>
    </div>
</template>
<script>
import utils from '../../lib/util'
import wsMethod from '../../lib/socketMethod'
    export default {
        name:"connectionLine",
        props: {
            sonData: Object,
            allAnswer: Object,
            serial:Number,
            buttonNum:Number,
            allData:Object,
        },
        data() {
            return {
                heart:{
                    questionDto:{
                        detailInfo:{}
                    }
                },
                rhythmBeatVal0:[],
                rhythmBeatVal1:[],
                rhythmBeatVal2:[],
                timeHer:'',
                advancedRadio:'',
                plays:0,
                answerType:null,
                valLine:[],
                lineIds:'',
                uid:this.$base64.decode(window.localStorage.getItem('uid-web')),
            }
        },
        components:{
        },
        watch: {
            'lineIds':function(now,old){
                if(now&&this.answerType)this.answerType=null
                this.$emit('storeLocally')
            },
            'buttonNum':function(now,old){
                if(now==this.serial){
                    this.$nextTick(()=>{
                        this.jsCanvasLoc(this)

                        // 赋值答案
                        let loc = localStorage.getItem('ceping-'+this.uid+'-'+this.allData.bId)? JSON.parse(localStorage.getItem('ceping-'+this.uid+'-'+this.allData.bId)):''
                        let ls = loc? loc.dataList[this.serial-1].obj.lineIds:''
                        
                        if(ls){
                            this.lineIds = ls
                            this.huaxian(ls.split(','))
                        }
                    })
                }else{
                    this.$emit('storeLocally')
                    // this.lineIds = this.allAnswer.obj.lineIds
                    this.$jsPlumb.deleteEveryConnection();
                    this.$jsPlumb.deleteEveryEndpoint()
                }
            },
            'answerType':function(now,old){
                this.$emit('storeLocally')
            },
        },
        beforeDestroy(){
            this.$jsPlumb.deleteEveryEndpoint()
            this.$jsPlumb.deleteEveryConnection()
        },
        computed:{},
        created(){},
        mounted(){
            this.heart = this.sonData
            this.$nextTick(function(){
                this.rhythmBeatVal0 = []
                if(this.heart.questionDto.detailInfo.detailsList&&this.heart.questionDto.detailInfo.detailsList.length>0){
                    let reg = /<div(([\s\S])*?)<\/div>/gi;
                    this.rhythmBeatVal0 = this.heart.questionDto.detailInfo.detailsList.map((item)=>{
                        item['msgImg'] = item.msg.indexOf("{%}") != -1? utils.dealText(item.msg).match(reg)[0]:''
                        item['msgText'] = utils.dealText(item.msg).replace(reg,'')
                        item['answerMsgImg'] = item.answerMsg.indexOf("{%}") != -1? utils.dealText(item.answerMsg).match(reg)[0]:''
                        item['answerMsgText'] = utils.dealText(item.answerMsg).replace(reg,'')
                        return item
                    })
                    // 排位
                    this.rhythmBeatVal1 = utils.deepClone2(this.rhythmBeatVal0)//原数据
                    this.rhythmBeatVal2 = utils.deepClone2(this.rhythmBeatVal1)//排位后数据
                    this.rhythmBeatVal2 = this.rhythmBeatVal2.sort(this.sortData)
                    this.$nextTick(()=>{
                        if(this.buttonNum == this.serial){
                            this.jsCanvasLoc(this)
                        }

                        // 赋值答案
                        if(this.allAnswer){
                            if(this.buttonNum==this.serial){
                                this.huaxian(this.allAnswer.obj.lineIds.split(','))
                            }
                            this.lineIds = this.allAnswer.obj.lineIds
                            this.answerType = this.allAnswer.obj.answerType
                        }
                    })
                }
            })
        },
        methods:{
            jsCanvasLoc(that){
                that.$jsPlumb.ready(function () {
                    that.$jsPlumb.setContainer(`diagramContainer${that.serial}`)
                    var common = {
                        isSource: true,
                        isTarget: true,
                        connector: 'Straight',
                        endpoint: 'Dot',
                        paintStyle: {
                            fill: 'white',
                            outlineStroke: 'blue',
                            strokeWidth: 3
                        },
                        hoverPaintStyle: {
                            outlineStroke: 'lightblue'
                        },
                        connectorStyle: {
                            outlineStroke: '#134DBA',
                            strokeWidth: 1
                        },
                        connectorHoverStyle: {
                            strokeWidth: 2
                        }
                    }
                    that.$jsPlumb.importDefaults({
                        ConnectionsDetachable: false
                    })
                    
                    for (let i = 0; i < that.rhythmBeatVal0.length; i++) {
                        that.$jsPlumb.addEndpoint(`anXx${i}_${that.serial}`, {
                            anchor: 'BottomCenter'
                        }, common)
                        that.$jsPlumb.addEndpoint(`mXx${i}_${that.serial}`, {
                            anchor: 'Top'
                        }, common) 
                    }
                })
                // 当链接建立前
                that.$jsPlumb.bind('beforeDrop', function (info) {
                    if(info.sourceId.substr(0,1) == info.targetId.substr(0,1)){
                        that.$message({showClose: true,message: `连接失败`})
                        return false
                    }else{
                        that.$nextTick(()=>{
                            that.statistical()
                        })
                        return true // 链接会自动建立
                    }
                })
                // 请单点击一下连接线, 
                // this.$jsPlumb.bind('click', function (conn, originalEvent) {
                    // if (window.prompt('确定删除所点击的链接吗？ 输入1确定') === '1') {
                    //     console.log(conn)
                    //     this.$jsPlumb.detach(conn)
                    // }
                // })
            },
            statistical(){
                this.$set(this,'valLine',[])
                // 获取JsPlumb对象内所有线数据
                var connections = this.$jsPlumb.getAllConnections();
                if(!connections){
                    this.lineIds = ''
                    return
                }

                for (let zo = 0; zo < this.rhythmBeatVal2.length; zo++) {
                    const eln = this.rhythmBeatVal2[zo];
                    var fleg = 1
                    for(var i in connections){
                        connections[i].sourceId;
                        connections[i].targetId;
                        
                        if(`anXx${zo}_${this.serial}`==connections[i].sourceId){
                            this.valLine.push(this.rhythmBeatVal1[connections[i].targetId.replace('mXx','').split('_')[0]].bId)
                            fleg = 2
                            continue;
                        }else if(`anXx${zo}_${this.serial}`==connections[i].targetId){
                            this.valLine.push(this.rhythmBeatVal1[connections[i].sourceId.replace('mXx','').split('_')[0]].bId)
                            fleg = 3
                            continue;
                        }
                    }
                    if(fleg==1) this.valLine.push('%')
                }

                if(this.serial == connections[i].sourceId.split('_')[1]){
                    this.lineIds = this.valLine.join(',').replace(/%/g,'')
                    this.$nextTick(()=>{
                        wsMethod.wsSend210(this.heart.bId,this.heart.questionId,{
                            allData:this.$parent.allData,
                            uuid1:this.$parent.uuid1,
                            firstStartDateVal:this.$parent.firstStartDateVal,
                        })
                    })
                }
            },
            huaxian(arr){
                let that = this
                // that.$jsPlumb.deleteEveryEndpoint()
                that.$nextTick(()=>{
                    for (let i = 0; i < that.rhythmBeatVal2.length; i++) {
                        for (let c = 0; c < that.rhythmBeatVal1.length; c++) {
                            if(arr[i]){
                                if(arr[i] == that.rhythmBeatVal1[c].bId)
                                that.goConnection(i,c)
                            }
                        }
                    }
                })
            },
            goConnection(i,e){
                this.$jsPlumb.deleteConnectionsForElement(`anXx${i}_${this.serial}`,{});
                this.$jsPlumb.connect({
                    source: `anXx${i}_${this.serial}`, 
                    target: `mXx${e}_${this.serial}`,
                    connector: 'Straight',
                    endpoint: 'Dot',
                    anchors: ['BottomCenter','Top'],
                    endpointStyle: { fill: 'transparent', outlineStroke: 'darkgray', outlineWidth: 2 },
                    paintStyle: {
                        fill: 'white',
                        outlineStroke: '#134CB9',
                        strokeWidth: 1
                    },
                    hoverPaintStyle: {
                        outlineStroke: 'lightblue'
                    },
                    connectorStyle: {
                        outlineStroke: '#134DBA',
                        strokeWidth: 1
                    },
                    connectorHoverStyle: {
                        strokeWidth: 2
                    },
                })
                this.$jsPlumb.importDefaults({
                    ConnectionsDetachable: false
                })
            },
            sortData(a, b) {
                return a.answerNum - b.answerNum
            },
            resetLine(){
                for (let zo = 0; zo < this.rhythmBeatVal2.length; zo++) {
                    const eln = this.rhythmBeatVal2[zo];
                    this.$jsPlumb.deleteConnectionsForElement(`anXx${zo}_${this.serial}`,{});
                }
                this.$set(this,'lineIds','0')
                this.$nextTick(()=>{
                    wsMethod.wsSend210(this.heart.bId,this.heart.questionId,{
                        allData:this.$parent.allData,
                        uuid1:this.$parent.uuid1,
                        firstStartDateVal:this.$parent.firstStartDateVal,
                    })
                })
            },
            changeAnswerType(val){
                this.answerType = val.answerType
            }
        }
    }
</script>
<style scoped lang="less">
    .rhythmClass{
        height: 100%;
        width: 100%;
        .zhiAudio{
            height: 33px;
            width: 100%;
            box-sizing: border-box;
            padding-left: 16px;
            .playNum{
                float: left;
                display: inline-block;
                height: 33px;
                width: 100px;
                .playNumIng{
                    display: inline-block;
                    img{
                        margin: 5px 0 0 15px;
                        vertical-align: text-bottom;
                    }
                }
            }
        }
        .explainText{
            box-sizing: border-box;
            padding:5px 0 0 16px;
            text-align: left;
            font-size: 12px;
            color: #A0A1A0;
        }
        .imgStyle{
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            padding: 25px 18px;
            padding-top: 0;
            .aginOnce{
                float: right;
                height: 25px;
                line-height: 0px;
            }
            
            // 图片单选 选项非为空
            .optionsHaveValue{
                height: 100%;
                width: 100%;
                position: relative;
                .line-box{
                    position: absolute;
                    top: 0;
                    height: 100%;
                    width: 19%;
                    .lBox-top{
                        position: absolute;
                        top: 0;
                        height: 40%;
                        width: 100%;
                        .an-text{
                            position: absolute;
                            top: 0;
                            height: 20%;
                            width: 100%;
                            font-size: 14px;
                            color: #000;
                            text-align: center;
                            background: #F4F8FE;
                        }
                        .an-text::before{
                            display: inline-block;
                            content: "";
                            height: 100%;
                            vertical-align: middle;
                        }
                        .an-img{
                            position: absolute;
                            top: 22%;
                            height: 55%;
                            width: 100%;
                            .tableimg{
                                height: 100%;
                                width: 100%;
                            }
                        }
                        .an-x{
                            position: absolute;
                            top: 80%;
                            height: 15%;
                            width: 100%;
                        }
                    }
                    .lBox-top-no{
                        height: 18%;
                        .an-text{
                            height: 45%;
                        }
                        .an-x{
                            top: 50%;
                            height: 30%;
                        }
                    }
                    .lBox-bottom{
                        position: absolute;
                        top: 60%;
                        height: 40%;
                        width: 100%;
                        .m-x{
                            height: 10%;
                            width: 100%;
                            margin-bottom: 7px;
                        }
                        .m-img{
                            height: 45%;
                            width: 100%;
                            margin-bottom: 7px;
                            .tableimg{
                                height: 100%;
                                width: 100%;
                            }
                        }
                        .m-text{
                            height: 20%;
                            font-size: 13px;
                            text-align: center;
                        }
                    }
                    .lBox-bottom-no{
                        top: 40%;
                        height: 60%;
                        .m-x{
                            height: 9%;
                        }
                        .m-img{
                            height: 65%;
                        }
                    }
                }
                .line-box1{width: 19%;left: 0;}
                .line-box2{width: 18%;left: 21%;}
                .line-box3{width: 18%;left: 41%;}
                .line-box4{width: 18%;left: 61%;}
                .line-box5{width: 19%;right: 0;}
            }
        }
    }
</style>
<style>
    .m-img .tableimg,
    .an-img .tableimg{
        height: 100%;
        width: 100%;

        position: relative;
        display: inline-block;
        vertical-align: middle;
    }
    .m-img .tableimg img,
    .an-img .tableimg img{
        width: 100%;
        height: 100%;
        object-fit: scale-down;
    }
</style>


// WEBPACK FOOTER //
// src/components/exam/connectionLine.vue